module.exports = "/_next/static/images/video_id_7102467719886425386-7d4d5cf37f100bc239d7ef59cc20fe88.jpg";